import { Platform } from 'react-native';

export type SupportContext = {
    pathname: string;
    authenticated: boolean;
    authReady: boolean;
    identityKey: string;
    hidden: boolean;
};

export type SupportWidget = {
    setContext(context: SupportContext): void;
    reset(): Promise<void>;
    destroy(): void;
};

declare global {
    interface Window {
        PaperzillaSupport?: {
            mount(options: {
                apiBase: string;
                context: SupportContext;
                getAccessToken: () => Promise<string | null>;
            }): SupportWidget;
        };
        __PZ_SUPPORT_WIDGET__?: SupportWidget;
    }
}

const configured = process.env.EXPO_PUBLIC_SUPPORT_PROVIDER;
export const supportProvider = configured === 'telegram' || configured === 'none'
    ? configured : 'intercom';
export const supportVisibilityEvent = 'pz:support-visibility';
const overlays = new Set<string>();

export function supportIsHidden() {
    return overlays.size > 0;
}

export function setSupportOverlay(name: string, visible: boolean) {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    if (visible) overlays.add(name);
    else overlays.delete(name);
    if (supportProvider === 'intercom') {
        const intercom = (window as Window & { Intercom?: (action: string, options: object) => void }).Intercom;
        intercom?.('update', { hide_default_launcher: supportIsHidden() });
    }
    window.dispatchEvent(new Event(supportVisibilityEvent));
}

export function resetSupportForLogout() {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    // Mark synchronously even if the widget failed to load or the service is offline.
    // A future widget must revoke the old anonymous binding before reading history.
    try { localStorage.setItem('pz-support:pending-reset', crypto.randomUUID()); } catch { /* optional storage */ }
    void window.__PZ_SUPPORT_WIDGET__?.reset().catch(() => undefined);
}
